const setVideoPlaceholder = () => {
  $('.video').each(function() {
    const $this = $(this);
    const $videoPlaceholder = $this.find('.video__placeholder');
    const videoId = $this.find('.video__inner').data('video-id');

    if ($this.hasClass('video--vimeo')) {
      $.ajax({
        url: `http://vimeo.com/api/v2/video/${videoId}.json`,
        type: 'GET',
        dataType: 'json'
      })
      .done(function(data) {
        $videoPlaceholder.css('background-image', 'url(' + data[0].thumbnail_large + ')');
      });
    } else if ($this.hasClass('video--youtube')) {
      $videoPlaceholder.css('background-image', 'url(http://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg)');
    }
  });
}

setVideoPlaceholder();

